import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { BLOG_ARTICLES, buildBlogArticleLd, buildBlogBreadcrumbLd, DEFAULT_OG_IMAGE } from "@/data/blog";

export const Route = createFileRoute("/_app/blog/$slug")({
  head: ({ params }) => {
    const post = BLOG_ARTICLES[params.slug];
    if (!post) {
      return buildHead({
        title: "Article not found — LohaLink Journal",
        description: "This LohaLink Journal article is unavailable.",
        canonical: `/blog/${params.slug}`,
        noindex: true,
      });
    }
    const heroAbs = post.heroImage.startsWith("http")
      ? post.heroImage
      : `https://lohalink.in${post.heroImage.startsWith("/") ? "" : "/"}${post.heroImage}`;
    return buildHead({
      title: post.title,
      description: post.description,
      canonical: `/blog/${post.slug}`,
      ogType: "article",
      image: DEFAULT_OG_IMAGE,
      jsonLd: [buildBlogArticleLd(post, heroAbs), buildBlogBreadcrumbLd(post)],
    });
  },
  component: lazyRouteComponent(() => import("@/pages/BlogPost")),
});
